import { gql } from "@apollo/client";

export const getUserNameByTag = gql`
  query Query($tag: String!) {
    getUserNameByTag(tag: $tag)
  }
`;

export const getUserBankDetails = gql`
  # query GetUserBankDetails($getUserBankDetailsId: ID!) {
  #   getUserBankDetails(id: $getUserBankDetailsId) {
  #     message
  #     user
  #     userBankDatails
  #     userFinancialDetails
  #   }
  # }
  query GetUserBankDetails {
    getUserBankDetails {
      message
      user
      userBankDatails
      userFinancialDetails
    }
  }
`;

export const getTransfersByUserId = gql`
  query GetTransfersByUserId {
    getTransfersByUserId {
      message
      status
      transfers {
        transferStatus
        transferType
        transferFee
        id
        createdAt
        balance
        amount
        purpose
        recepientTag
        recipientAccountId
        recipientAccountNumber
        recipientAddress
        recipientBankName
        recipientPhoneNumber
        recipientFullName
      }
      error
    }
  }
`;
export const fetchBeneficiaryDetails = gql`
  # query Query($userId: String!) {
  #   fetchBeneficiaryDetails(userId: $userId) {
  #     recipientPhoneNumber
  #     recipientFullName
  #     recipientBankName
  #     recipientTag
  #     recipientAccountNumber
  #   }
  # }
  query FetchBeneficiaryDetails {
    fetchBeneficiaryDetails {
      recipientPhoneNumber
      recipientFullName
      recipientBankName
      recipientTag
      recipientAccountNumber
    }
  }
`;
